import { observer } from 'mobx-react-lite';
import {
    otherAccessOptionsGroupText,
    folderOwnerAccessOptionText,
    folderContactAccessOptionText,
    folderVisibleAccessOptionText,
} from './FolderPermissionFormOtherGroup.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import Permission from 'owa-service/lib/contract/Permission';

import { changeFolderPermissionProperty } from '../actions/internalActions';
import PERMISSION_CONSTANTS from '../utils/permissionConstants';
const styles = require('./FolderPermissionForm.scss');

// Interface for defining props for the component.
interface FolderPermissionFormOtherGroupProps {
    permission: Permission;
}

/**
 * This component shows Other Group in folder permission form.
 */
export default observer(function FolderPermissionFormOtherGroup(
    props: FolderPermissionFormOtherGroupProps
) {
    const { permission } = props;
    return (
        <div className={styles.permissionFormPermissionsGroup}>
            <label>{loc(otherAccessOptionsGroupText)}</label>
            <>
                <Checkbox
                    checked={permission.IsFolderOwner}
                    label={loc(folderOwnerAccessOptionText)}
                    onChange={onChangeIsFolderOwner}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
                <Checkbox
                    checked={permission.IsFolderContact}
                    label={loc(folderContactAccessOptionText)}
                    onChange={onChangeIsFolderContact}
                    disabled={typeof permission.UserId.DistinguishedUser !== 'undefined'}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
                <Checkbox
                    checked={permission.IsFolderVisible}
                    label={loc(folderVisibleAccessOptionText)}
                    onChange={onChangeIsFolderVisible}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
            </>
        </div>
    );
});

/**
 * This function is called when 'IsFolderOwner' permission property is modified in the permission form.
 * @param event Event object
 * @param value Value of the property
 */
function onChangeIsFolderOwner(event, value: boolean) {
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.IS_FOLDER_OWNER, value);
}

/**
 * This function is called when 'IsFolderContact' permission property is modified in the permission form.
 * @param event Event object
 * @param value Value of the property
 */
function onChangeIsFolderContact(event, value: boolean) {
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.IS_FOLDER_CONTACT, value);
}

/**
 * This function is called when 'IsFolderVisible' permission property is modified in the permission form.
 * @param event Event object
 * @param value Value of the property
 */
function onChangeIsFolderVisible(event, value: boolean) {
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.IS_FOLDER_VISIBLE, value);
}
